import { FieldGroup } from '@/components/ui/field.tsx';
import { RadioGroup } from '@/components/ui/radio-group.tsx';
import type { Product } from '@/types/product.type.ts';
import ProductRadioItem from '@/views/products/components/ProductRadioItem.tsx';

type Props = {
  products: Product[];
  value: string;
  onValueChange: (value: string) => void;
};

export default function ProductRadioGroup({ products, value, onValueChange }: Props) {
  return (
    <FieldGroup data-slot="product-radio-group">
      <RadioGroup
        value={value}
        onValueChange={onValueChange}
        className="grid grid-cols-[repeat(auto-fill,min(100%/2-1.25rem,155px))] justify-center gap-x-5 gap-y-6 sm:justify-start"
      >
        {products.map((product) => (
          <ProductRadioItem
            key={product.uuid}
            product={product}
            checked={value === product.uuid}
            onSelect={() => onValueChange(product.uuid)}
            onDeselect={() => onValueChange('')}
          />
        ))}
      </RadioGroup>
    </FieldGroup>
  );
}
